import React from "react";
import { useAppSelector } from "@/core/store/reduxHooks";
import { getUser } from "@/core/store/app/AppSlice";
import { PostPaywallGuestContent } from "@/components/modules/Post/Paywall/PostPaywallGuestContent";
import { PostPaywallUserContent } from "@/components/modules/Post/Paywall/PostPaywallUserContent";
import { PostPaywallProps } from "@/types/modules/post/components";

export const PostPaywall: React.FC<PostPaywallProps> = ({ onUnlockContent, postId }) => {
  const user = useAppSelector(getUser);

  if (!user) {
    return <PostPaywallGuestContent postId={postId} />;
  }

  return <PostPaywallUserContent onUnlockContent={onUnlockContent} postId={postId} />;
};
